<template>
  <v-dialog :value="value" persistent max-width="600px">
    <nv-form
      v-if="item != null"
      :errors="formErrors"
      :title="formTitle"
      :loading="loading"
      @cancel="formCancel"
      @nv-submit="formSubmit"
    >
      <v-row dense>
        <v-col cols="12">
          <v-text-field
            ref="pattern"
            v-model="item.pattern"
            label="Pattern"
            :rules="rules.pattern"
          />
        </v-col>
        <v-col cols="12">
          <v-row>
            <v-col cols="7">
              <tree-search
                v-if="item.id"
                ref="tree-search"
                v-model="item.tree_id"
                :rules="rules.treeId"
                mode="classification"
                :country-code="item.localization"
              />
            </v-col>

            <v-col cols="4">
              <div class="d-flex align-center">
                <v-icon class="mr-5">mdi-filter-variant</v-icon>
                <v-select
                  v-model="item.localization"
                  :items="filter_localization"
                  label="Select a localization"
                  :disabled="editing || processed || loading"
                  :default="'default'"
                  height="40"
                />
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6">
          <rules-status-selector v-model="item.status" product="video" />
        </v-col>
        <v-col cols="12" sm="6">
          <v-select
            ref="property"
            v-model="item.property"
            :items="videoProperties"
            :rules="rules.property"
            label="Property"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <owl-date-picker
            ref="start-date"
            v-model="item.effective_start_date"
            label="Start Date"
            data-cy="start-date"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <owl-date-picker
            ref="end-date"
            v-model="item.effective_end_date"
            :start-date="item.effective_start_date"
            label="End Date"
          />
        </v-col>
      </v-row>
      <div v-if="item.localization == '*'" style="color: #ff8482;">
        * Any changes made to the default rule will reflect in the localised rule as well
      </div>
    </nv-form>
  </v-dialog>
</template>

<script>
import HTTP from '@/api/ant';
import { FormMixin, enumFetch } from '@nielsen-media/ui-toolkit-vue-api';
import Rules from 'bsm-validation-rules';
import TreeSearch from '@/components/mv/TreeSearch';
import OwlDatePicker from '@/components/OwlDatePicker';
import RulesStatusSelector from '@/components/cls/RulesStatusSelector.vue';

const rules = {
  pattern: [Rules.presence()],
  property: [Rules.presence()],
  treeId: [Rules.presence()],
};

export default {
  components: { RulesStatusSelector, OwlDatePicker, TreeSearch },
  mixins: [FormMixin],
  data: () => ({
    formContext: 'Rule',
    videoProperties: [],
    rules,
    localization: '*',
    filter_localization: [
      { text: 'default', value: '*' },
      { text: 'us', value: 'us' },
    ],
  }),
  created() {
    this.enumFetch(HTTP, {
      videoProperties: '/video/rules/enum/properties',
    });
  },
  methods: {
    formSave() {
      return this.submitForm(HTTP, '/video/rules', {
        success: ({ data }) => {
          this.$flash('success', `${data.name} rule ${this.formSuccessMsg}`);
        },
      });
    },
    enumFetch,
  },
};
</script>
